// extracted by mini-css-extract-plugin
module.exports = {"machineIcon":"style_machineIcon__3nsjB"};